import { combineReducers } from 'redux';
import { createSelector } from 'reselect';

import checkins from './checkins';
import dispatches from './dispatches';
import regions from './regions';

export default combineReducers({
  regions,
  dispatches,
  checkins,
});

export * from './regions';

export const selectDomain = (state) => state.domain;

export const selectRegions = createSelector(selectDomain, (state) => state.regions);
export const selectDispatches = createSelector(selectDomain, (state) => state.dispatches);
export const selectCheckins = createSelector(selectDomain, (state) => state.checkins);
